import List from "./list/list.store";
import Individual from "./individual/list.store";

export default {
  modules: { List, Individual },
};
